"use strict";


import data from '../data/faq';

// let isMktPlace = url.search(/acao=portctrlmktplace/gi) > -1;

let template =
    `<div class="faq--list--item">
        <label for="tab-label{{id}}" class="faq--list--item--question">{{question}}</label>
        <div id="tab-label{{id}}" class="faq--list--item--answer">
            <p class="faq--list--item--answer--description">{{answer}}</p>
        </div>
    </div>`;


export default {

    buildFaq: () => {
        const url = window.location.href;
        let isMktPlace = url.search(/acao=portctrlmktplace/gi) > -1;

        let $faq = document.querySelector('.faq--list');
        let faqData = isMktPlace ? data.faqmkt : data.faq;


        $faq.innerHTML = '';

        const makeFaq = (item) => {
            let card = template;

            return  card.replace(/{{id}}/gi, item.id)
                        .replace(/{{question}}/gi, item.question)
                        .replace(/{{answer}}/gi, item.answer);
        };


        faqData.map(item => {
            $faq.innerHTML += makeFaq(item);
        });

    },

    buildAccordion: () => {

        var acc = document.getElementsByClassName("faq--list--item--question");
  
        for (let i = 0; i < acc.length; i++) {
            acc[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var panel = this.nextElementSibling;
                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        } 
    } 
}